import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { DepositType } from 'storeTypes'
import { sendMessageToWorkerWithResponse, constants } from 'helpers'

export const getStoredVeDeposit = createAsyncThunk<
    DepositType | undefined,
    string
>('storedVeDeposits/getStoredVeDeposit', async (veCode) => {
    const veDeposit = await sendMessageToWorkerWithResponse({
        [constants.MESSAGES.GET_VE_DEPOSIT]: veCode
    })

    return veDeposit as DepositType | undefined
})

export const resetStoredVeDeposit = createAsyncThunk<undefined>(
    'storedVeDeposits/resetStoredVeDeposit',
    async () => {
        return undefined
    }
)

type StoredVeDepositsState = {
    veDeposit?: DepositType
}

const initialState: StoredVeDepositsState = {
    veDeposit: undefined
}

const storedVeDepositsSlice = createSlice({
    name: 'veDeposits',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                getStoredVeDeposit.fulfilled,
                (state, action: PayloadAction<DepositType | undefined>) => {
                    state.veDeposit = action.payload
                }
            )
            .addCase(resetStoredVeDeposit.fulfilled, (state) => {
                state.veDeposit = undefined
            })
    }
})

export default storedVeDepositsSlice.reducer
